import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

// Páginas específicas que carregam mensagens dinamicamente
import LojaIntegradaPage from "./loja-integrada/LojaIntegradaPage";
import PlatformsMainPage from "./PlatformsMainPage";
import Talk2PayCadastralPage from "./talk2pay/home/Talk2PayCadastralPage";
import Talk2PayDocumentsPage from "./talk2pay/home/Talk2PayDocumentsPage";
import Talk2PayGeneralInfoPage from "./talk2pay/home/Talk2PayGeneralInfoPage";
import Talk2PayHomePage from "./talk2pay/home/Talk2PayHomePage";
import Talk2PayRatesPage from "./talk2pay/home/Talk2PayRatesPage";
import { STATEMENT_FILTER_STORAGE_KEY } from "@/components/screens/Platforms/Talk2payHome";
import Talk2PayStatementPage from "./talk2pay/home/Talk2PayStatementPage";
import Talk2PayConnectionPage from "./talk2pay/Talk2PayConnectionPage";
import WhatsAppPage from "./whatsapp/WhatsAppPage";
import WhatsAppBspPage from "./whatsapp-bsp/WhatsAppBspPage";

const SettingsPlatformsPage: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!pathname.includes("talk2pay/home")) {
      sessionStorage.removeItem(STATEMENT_FILTER_STORAGE_KEY);
    }
  }, [pathname]);

  return (
    <Routes>
      {/* WhatsApp */}
      <Route path="whatsapp/:lang" element={<WhatsAppPage />} />

      {/* WhatsApp BSP */}
      <Route path="whatsapp-bsp/:lang" element={<WhatsAppBspPage />} />

      {/* Talk2Pay Connection */}
      <Route path="talk2pay/:lang" element={<Talk2PayConnectionPage />} />

      {/* Talk2Pay Home - Página principal (Statement) */}
      <Route path="talk2pay/home/:lang" element={<Talk2PayHomePage />} />

      {/* Talk2Pay Home - Rates */}
      <Route path="talk2pay/home/rates/:lang" element={<Talk2PayRatesPage />} />

      {/* Talk2Pay Home - Statement */}
      <Route path="talk2pay/home/statement/:lang" element={<Talk2PayStatementPage />} />

      {/* Talk2Pay Home - Documents */}
      <Route path="talk2pay/home/documents/:lang" element={<Talk2PayDocumentsPage />} />

      {/* Talk2Pay Home - General Information */}
      <Route path="talk2pay/home/general-information/:lang" element={<Talk2PayGeneralInfoPage />} />

      {/* Talk2Pay Home - Cadastral Situation */}
      <Route path="talk2pay/home/cadastral-situation/:lang" element={<Talk2PayCadastralPage />} />

      {/* Loja Integrada */}
      <Route path="loja-integrada/:lang" element={<LojaIntegradaPage />} />

      {/* Página principal de Plataformas — deve ficar por último */}
      <Route path=":lang" element={<PlatformsMainPage />} />
    </Routes>
  );
};

export default SettingsPlatformsPage;
